import { useState } from 'react'
import CreateMeteringBase from './modals/CreateMeteringBase/CreateMeteringBase'
import CreateMeteringFormatSelector from './modals/CreateMeteringFormatSelector/CreateMeteringFormatSelector'
import CreateMeteringForm from './modals/CreateMeteringForm/CreateMeteringForm'

export function CreateMeteringModalOrchestrator({
  updateMeteringModalVisibility,
}: {
  updateMeteringModalVisibility: () => void
}) {
  const [currentOpenModal, setCurrentOpenModal] = useState('')
  switch (currentOpenModal) {
    case 'CreateMeteringFormatSelector':
      return (
        <CreateMeteringFormatSelector
          showModal={currentOpenModal === 'CreateMeteringFormatSelector'}
          updateModalVisibility={updateMeteringModalVisibility}
        />
      )
    case 'CreateMeteringForm':
      return (
        <CreateMeteringForm
          showModal={currentOpenModal === 'CreateMeteringForm'}
          updateModalVisibility={updateMeteringModalVisibility}
        />
      )
    default:
      return (
        <CreateMeteringBase
          showModal={currentOpenModal === ''}
          updateModalVisibility={updateMeteringModalVisibility}
          updateCurrentOpenModal={setCurrentOpenModal}
        />
      )
  }
}
